import {ChangeDetectionStrategy, Component, EventEmitter, HostBinding, HostListener, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'tr[simpleGridRecord]',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <ng-content></ng-content>
  `
})
export class SimpleGridRecordComponent implements OnInit {
  // we have to Inject -> forwardRef as SimpleGridTable is not yet due to load order of files
  // constructor(@Inject(forwardRef(() => SimpleGridTable)) i_table: SimpleGridTable) {
  // constructor(i_table: SimpleGridTable) {
  //   this.m_table = i_table;
  // }

  @Output()
  whenDoubleClicked: EventEmitter<any> = new EventEmitter();

  @Output()
  onClicked: EventEmitter<any> = new EventEmitter();

  @HostBinding('class.selectedTr')
  selectedClass = false;

  @HostListener('dblclick', ['$event'])
  doubleClicked(event) {
    this.setSelected();
    this.whenDoubleClicked.emit({
      target: event.target,
      item: this.item ? this.item : null
    });
    return true;
  }



  @HostListener('click', ['$event'])
  onSelected(event) {
    if (!this.selectable)
      return;
    this.setSelected();
    this.onClicked.emit({
      target: event.target,
      item: this.item ? this.item : null
    });
    return true;
  }

  @Input()
  set index(i_index: number) {
    this.m_index = i_index;
  }



  constructor() {
  }

  // private m_table: SimpleGridTable;
  // private m_table;
  private m_index;

  @Input()
  m_table;

  @Input()
  item;

  @Input()
  selectable = true;

  // @Input()
  // set table(i_table) {
  //     this.m_table = i_table;
  // }


  get index() {
    return this.m_index;
  }

  ngOnInit() {
    const selected: SimpleGridRecordComponent = this.m_table.getSelected();
    // even though the index is same as this, the Immutable data propSelectedModel
    // is out of sync inside table, so we need to update to latest version of this
    if (selected && selected.m_index === this.index)
      this.setSelected();
  }

  private setSelected() {
    this.m_table.setSelected(this);
    this.selectedClass = true;
  }
}
